import { Tooltip } from "antd";
import { twMerge } from "tailwind-merge";
import { IconHelp } from "@icons/index";
import { RequiredMark } from "@components/RequiredMark";

export interface SectionLabelProps {
  className?: string;
  required?: boolean;
  tooltip?: string;
  size?: "sm" | "md";
  children: React.ReactNode;
}

export const SectionLabel = ({ className, required, tooltip, size = "md", children }: SectionLabelProps) => (
  <div className={twMerge("flex items-center gap-[4px]", className)}>
    <span
      className={twMerge(
        "text-kds-fg",
        size === "md" ? "text-[16px] font-semibold leading-[24px]" : "text-[14px] font-medium leading-[20px]",
      )}
    >
      {children}
      {required && <RequiredMark />}
    </span>
    {tooltip && (
      <Tooltip title={tooltip}>
        <span className="inline-flex">
          <IconHelp
            className={twMerge(
              "cursor-pointer text-kds-fg-subtle",
              size === "md" ? "h-[16px] w-[16px]" : "h-[14px] w-[14px]",
            )}
          />
        </span>
      </Tooltip>
    )}
  </div>
);
